import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { Show } from '@sc/types';
import { ShowsService } from '../../services/shows/shows.service';

@Component({
  selector: 'sc-show-select-menu',
  templateUrl: './show-select-menu.component.html',
  styleUrls: ['./show-select-menu.component.scss'],
})
export class ShowSelectMenuComponent implements OnInit {
  @Input() selectedShowID: string;
  availableShows$ = this.showsService.availableShows$;

  constructor(private popoverController: PopoverController, private showsService: ShowsService) {}

  ngOnInit() {}

  selectShow(show: Show) {
    this.popoverController.dismiss(show);
  }
}
